import { Component } from '@angular/core';

@Component({
  selector: 'app-investors-dispute',
  templateUrl: './investors-dispute.component.html',
  styleUrl: './investors-dispute.component.scss',
})
export class InvestorsDisputeComponent {
  isExpanded: boolean = false;

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
